import {
  type SomeObject,
  overwriteObject,
} from '../../../private/overwrite-object';
import { DeepPartial } from '../../types/helpers';

/** Overwrite properties of target object. The override object
 * should be of the same type as the target.
 *
 * If we want to add missing properties to the target,
 * the `canAddProperties` argument should be set to `true`
 * (`false` by default).
 */
export const overrideObject = <T extends SomeObject>(
  target: T,
  override: DeepPartial<T>,
  canAddProperties = false,
): T => overwriteObject(target, override, canAddProperties);

/** Override existing properties of the target object and add new ones. */
export const augmentObject = <T extends SomeObject, G extends SomeObject>(
  target: T,
  override: G,
): T & G => overwriteObject(target, override, true);
